'use client';

import { useEffect, useState } from 'react';

export function useObjectUrl(source: File | Blob | null | undefined): string {
    const [url, setUrl] = useState('');

    useEffect(() => {
        if (!source) {
            setUrl('');
            return;
        }
        const objectUrl = URL.createObjectURL(source);
        setUrl(objectUrl);
        return () => URL.revokeObjectURL(objectUrl);
    }, [source]);

    return url;
}
